export default __webpack_public_path__ + "bc34d5a7417b5be37cb4faf1f017bbbc.png";